
var paymentWrapper = {
  appendScript: (script) => {
    $.getScript(script).done(function () {
    });
  },
  proceedPayment: (merchantId, sharedKey, amount, url, email, mobile, paymentMode, noOfPayments, paymentData, nachData, sucFun, errFun) => {
    var response = "";
    var dubuggy = { merchantId, sharedKey, amount, url, email, mobile, paymentMode, noOfPayments, paymentData, nachData };
    //console.log(dubuggy);
   
    try {
     
     response = DGProcessPay(merchantId, sharedKey, amount, url, email, mobile, paymentMode, noOfPayments, paymentData, nachData);
      //response = "<Response><MId>800030</MId><RespCode>1000</RespCode><PaymentMode>Card</PaymentMode><Payments><NoOfPayments>1</NoOfPayments><Payment1><Payment1></Payment1><RefId></RefId><TnxId>921487632849825</TnxId><ApprovalCode>699654</ApprovalCode><LastFour>7226</LastFour><Name></Name><Expiry></Expiry><Date></Date><CardBrand>Master Card</CardBrand><BankTransactionId></BankTransactionId><KeyField1></KeyField1><KeyField2></KeyField2><KeyField3></KeyField3><KeyField4></KeyField4><KeyField5></KeyField5></Payment1></Payments></Response>";
        sucFun(response);
        //console.log(response);
      }
    catch (err) {
          console.log(err);
          errFun(response);
      }
    }
  };
  
export {paymentWrapper};
        
        
        
        
        
        
        
;
